export default __webpack_public_path__ + "static/media/006-curry rice.9504c03a.svg";